import { Link } from 'react-router-dom';
import type { BlogPost } from '../../data/blog';
import { formatBlogDate } from '../../data/blog';

interface BlogListItemProps {
  post: BlogPost;
  index: number;
}

export function BlogListItem({ post, index }: BlogListItemProps) {
  return (
    <article
      className="blog-tile reveal-item"
      style={{ transitionDelay: `${index * 0.08}s` }}
    >
      <Link to={`/blog/${post.slug}`} className="blog-tile__link">
        <div className="blog-tile__media">
          <img src={post.image} alt="" loading="lazy" className="blog-tile__image" />
        </div>

        <div className="blog-tile__body">
          <span className="blog-tile__category">{post.category}</span>
          <h2 className="blog-tile__title">{post.title}</h2>
          <div className="blog-tile__meta">
            <time dateTime={post.date}>{formatBlogDate(post.date)}</time>
            <span className="blog-tile__dot" aria-hidden />
            <span>{post.readTime}</span>
          </div>
          <p className="blog-tile__excerpt">{post.excerpt}</p>
          <span className="blog-tile__cta">
            Read article
            <svg viewBox="0 0 16 16" aria-hidden className="blog-tile__arrow">
              <path
                fill="currentColor"
                d="M3 8h8.59L8.29 4.71 9.71 3.29 14.41 8l-4.7 4.71-1.42-1.42L11.59 9H3V8z"
              />
            </svg>
          </span>
        </div>
      </Link>
    </article>
  );
}
